if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.container = this.querySelector('[role="document"]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.buildControls();

        this.container.addEventListener('scroll', debounce(this.syncActiveMedia.bind(this), 100), { passive: true });
        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') this.goTo(this.activeIndex - 1);
          if (event.code === 'ArrowRight') this.goTo(this.activeIndex + 1);
        });
      }

      // Read on demand: product-info.js replaces the modal content when the variant changes.
      get slides() {
        return Array.from(this.container.children).filter((element) => element.hasAttribute('data-media-id'));
      }

      get activeIndex() {
        return Math.max(
          this.slides.findIndex((element) => element.classList.contains('active')),
          0
        );
      }

      buildControls() {
        const dialog = this.querySelector('[role="dialog"]');
        const createButton = (name, label, path, step) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `product-media-modal__nav product-media-modal__nav--${name}`;
          button.setAttribute('aria-label', label);
          button.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="${path}"/></svg>`;
          button.addEventListener('click', () => this.goTo(this.activeIndex + step));
          // ModalDialog closes media modals on any mouse pointerup; keep it open when navigating.
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          dialog.appendChild(button);
          return button;
        };

        this.previousButton = createButton('prev', 'Photo précédente', 'M15 5l-7 7 7 7', -1);
        this.nextButton = createButton('next', 'Photo suivante', 'M9 5l7 7-7 7', 1);

        this.counter = document.createElement('div');
        this.counter.className = 'product-media-modal__counter';
        this.counter.setAttribute('aria-live', 'polite');
        dialog.appendChild(this.counter);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const slides = this.slides;
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        const index = Math.max(
          slides.findIndex((element) => element.getAttribute('data-media-id') === openedMediaId),
          0
        );
        const activeMedia = slides[index];
        if (!activeMedia) return;

        this.setActive(index);
        this.container.scrollTo({ left: index * this.container.clientWidth, behavior: 'instant' });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      goTo(index) {
        const slides = this.slides;
        if (index < 0 || index > slides.length - 1) return;

        this.setActive(index);
        this.container.scrollTo({
          left: index * this.container.clientWidth,
          behavior: this.reducedMotion.matches ? 'instant' : 'smooth',
        });
      }

      // Keeps the counter and arrows in step when the visitor swipes between photos.
      syncActiveMedia() {
        if (!this.hasAttribute('open') || !this.container.clientWidth) return;

        const index = Math.round(this.container.scrollLeft / this.container.clientWidth);
        if (index !== this.activeIndex) this.setActive(index);
      }

      setActive(index) {
        const slides = this.slides;
        slides.forEach((element, position) => element.classList.toggle('active', position === index));

        this.counter.textContent = slides.length > 1 ? `${index + 1} / ${slides.length}` : '';
        this.previousButton.hidden = index === 0;
        this.nextButton.hidden = index === slides.length - 1;
      }
    }
  );
}
